<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0 justify-content-between d-flex">
        <h5 class="card-title font-bold py-3">
          نمایش درخواست های
          {{ seller && seller.full_name ? seller.full_name : "..." }}
        </h5>
        <div style="flex: 1"></div>
        <router-link :to="`/admin/change-status-sellers/${seller && seller.id ? seller.id : ''
          }?type=return&seller_name=${seller && seller.full_name ? seller.full_name : ''
          }`
          " class="btn"
          style="color: #fff;background-color: rgb(173 31 31 / 77%);border-color: rgb(211 215 215 / 63%);line-height: 1.1;">
          بازگشت تنوع ها
        </router-link>
        <router-link :to="`/admin/change-status-sellers/${seller && seller.id ? seller.id : ''
          }?type=all`
          " class="btn mr-2"
          style="color: #fff;background-color: #83c7b4;border-color: rgb(211 215 215 / 63%);line-height: 1.1;">
          ارسال همه‌ی تنوع های جدید
          <span class="bg-dot">{{ numberListItem(sellerRequests.data) }}</span>
        </router-link>
      </div>
      <div class="content-btn-filter">
        <button class="btn-filter badge" @click="filterStatus(filter)" v-for="(filter, index) in filterBtns"
          :key="filter.id ? filter.id : index" :class="filterActive == filter.status ? filter.style : ''">
          {{ filter.title }}
        </button>
      </div>
      <div class="card-body">
        <form class="mt-3" @submit.prevent="requestProduct">
          <div class="row justify-content-center">
            <b-form-group label="ارسال تنوع" class="col-3">
              <b-form-input autocomplete="off" autofocus ref="productSku" v-model="productSku"
                @keypress.prevent.enter="requestProduct" :disabled="disabled" type="text" />
            </b-form-group>
          </div>
        </form>
        <div class="content-card">
          <article v-for="(item, index) in sellerRequests.data" :key="index" class="card">
            <figure class="image-card">
              <img :src="item.image && item.image.length ? item.image[0].url : ''" alt="" />
              <div class="status-box">
                <span>
                  {{ item.created_at | persianDate }}
                </span>
                <p>
                  <span v-if="item.status == 'pending'" class="badge badge-warning status">جدید</span>
                  <span v-else-if="item.status == 'sent'" class="badge badge-secondary status">ارسال شده</span>
                  <span v-else-if="item.status == 'sold'" class="badge badge-success status">فروخته شده</span>
                  <span v-else-if="item.status == 'checked'" class="badge badge-info status">بررسی شده</span>
                  <span v-else class="badge badge-danger status">برگشت داده شده</span>
                </p>
              </div>
            </figure>
            <div class="info">
              <h3 class="title">
                {{ item.product_title }}
              </h3>
              <ul class="info-list" v-if="
                item.variety &&
                item.variety.attributes &&
                item.variety.attributes.length
              ">
                <li v-for="(attribute, index) in item.variety.attributes" :key="attribute.id ? attribute.id : index">
                  <span>
                    {{ `${attribute.label} :` }}
                  </span>
                  <b>
                    {{ attribute.pivot.value }}
                  </b>
                </li>
                <li>
                  <span>بارکد :</span>
                  <b>
                    {{ item.var_barcode }}
                  </b>
                </li>
              </ul>
            </div>
          </article>
        </div>
        <div class="flex-row justify-content-center">
          <!-- <table class="table table-responsive-sm table-bordered table-hover">
            <thead style="background: rgb(192 210 225 / 42%);">
              <tr>
                <th>ردیف</th>
                <th>نام تنوع</th>
                <th>بارکد تنوع</th>
                <th>تصویر تنوع</th>
                <th>وضعیت درخواست</th>
                <th>تاریخ دریافت درخواست</th>
                <th>ارسال تکی</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in sellerRequests.data"
                :style="
                  item.status == 'pending'
                    ? 'background: rgb(255 218 218 / 16%)'
                    : item.status == 'sold'
                    ? 'background: rgb(227 255 218 / 28%)'
                    : item.status == 'sent'
                    ? 'background: rgb(240 255 255 / 19%)'
                    : item.status == 'checked'
                    ? 'background: rgb(144 179 186 / 7%);'
                    : 'background: rgb(205 205 205 / 20%)'
                "
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.var_name }}</td>
                <td>{{ item.var_barcode }}</td>
                <td>
                  <a v-if="item.image" target="_blank">
                    <ImageHolder
                      style="max-height: 70px"
                      v-if="item.image"
                      :image="item.image"
                    >
                      <img :src="item.image.url" />
                    </ImageHolder>
                  </a>
                </td>
                <td>
                  <span
                    v-if="item.status == 'pending'"
                    class="badge badge-warning status"
                    >جدید</span
                  >
                  <span
                    v-else-if="item.status == 'sent'"
                    class="badge badge-secondary status"
                    >ارسال شده</span
                  >
                  <span
                    v-else-if="item.status == 'sold'"
                    class="badge badge-success status"
                    >فروخته شده</span
                  >
                  <span
                    v-else-if="item.status == 'checked'"
                    class="badge badge-info status"
                    >بررسی شده</span
                  >
                  <span v-else class="badge badge-danger status"
                    >برگشت داده شده</span
                  >
                </td>
                <td>{{ item.created_at | persianDate }}</td>
                <td>
                  <router-link
                    :to="
                      `/admin/change-status-sellers/${seller.id}?type=once&var_name=${item.var_name}&seller_name=${seller.full_name}`
                    "
                    class="btn btn-sm btn-info"
                  >
                    ارسال
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table> -->
          <pagination :router="true" v-if="sellerRequests && sellerRequests.data != ''" :disabled="disabled" :limit="2"
            :data="sellerRequests" @pagination-change-page="changePage" />
        </div>
        <Loading v-if="$root.isEmptyObject(seller) || loader" />
      </div>
    </div>
  </main>
</template>

<script>
import SellerDetailImpl from "@@/core/pages/SalesManagement/SalesManagementSellerDetail/SellerDetailImpl";
export default {
  extends: SellerDetailImpl,
};
</script>
<style scoped src="@@/core/pages/SalesManagement/SalesManagementSellerDetail/SellerDetailStyle.css"></style>
<style>
.table-responsive-sm {
  height: auto !important;
}
</style>
